


























// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '@/TokenUser';
import { Alert, alertChannel, alertStatus } from '@/Alert';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_topshot from '../utils_topshot';
import * as utils_tracker from '../utils_tracker';
import { globalUC } from '../UserCache';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import { Feedback, roleType } from '@/Feedback';

@Component({
  name: 'FeedbackForm',
  components: { ModalWrapperComponent }
})
export default class FeedbackFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public auctionId: string = null
  public ratee: string = null
  public rateeUsername: string = null
  public rateeRole: roleType = null
  public feedback: string = null

  public ratingOptions: Array<{ label: string, rating: number }> = [
    { label: '★★★★★ Excellent', rating: 5 },
    { label: '★★★★ Good', rating: 4 },
    { label: '★★★ Fair', rating: 3 },
    { label: '★★ Poor', rating: 2 },
    { label: '★ Awful', rating: 1 },
  ]
  public rating: { label: string, rating: number } = this.ratingOptions[0]

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get MAX_FEEDBACK_NOTE(): number { return Feedback.MAX_FEEDBACK_NOTE }

  public get okButtonDisabled(): boolean {
    return !this.feedback || this.feedback.trim().length === 0
  }

  public onCancel() {
    this.$emit('close', null)
    this.clearFields()
  }

  public onOK() {
    this.post()
    return
  }

  public clearFields() {
    this.feedback = null
  }

  public async onShow(dynamicProps: any) {
    this.clearFields()
    this.auctionId = dynamicProps.auctionId
    this.ratee = dynamicProps.ratee
    this.rateeUsername = dynamicProps.rateeUsername
    this.rateeRole = dynamicProps.rateeRole
  }

  public async post() {
    // validate form fields
    let abort: boolean = false

    // fields
    if (!this.feedback || this.feedback.trim().length === 0) {
      utils.toast(this, 'Error', 'You must enter feedback text.')
      abort = true
    }

    if (abort) return

    // make POST or PUT call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/topshot/feedback';
      const postData: any = { auctionId: this.auctionId, ratee: this.ratee, text: this.feedback, rating: this.rating.rating } 
      const response: any = await utils.makePostCall(url, postData)
      if (!response || !response.data) throw(new Error('FeedbackFormComponent.onOK() got null response or null response.data'))

      // something is wrong
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

      // success
      if (response.data.feedback) {
        const feedback: Feedback = new Feedback(response.data.feedback)
        utils.toast(this, 'Success', `Feedback Posted.`)
        this.$emit('close', feedback)
        this.clearFields()

        utils_tracker.track(`Feedback Created`, { auctionId: this.auctionId, user: this.user.getIdAsString() })
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not post feedback')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // utils_tracker.track(`Auction Form Shown`, {  user: this.user.getIdAsString() })

  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
